export default "/static/build/reward-v3.jpg";